import { listParams, mapParams, store } from './Map'
import { updatePagination } from './MapPagination'
import { map, updateMapCenter, updateMapMarkers, updateMapInfoWindows, updateMapZoom, onMarkerClick } from './MapMap'

const resultsList = document.querySelector('[data-map-resultsList]')

// result markup
function getPrototype(index, structure) {
  
  const structureTypes = structure.structure_type.label ? structure.structure_type.label : ''
  const postcode = structure.postcode.padStart(5, '0')

  let structureTypesFormated = ``
  let facebookProto = ''
  let webProto = ''
  let infosProto = ''
  let phoneNumberProto = ''

  structureTypes.sort()
  structureTypes.forEach(structureType => {
    structureTypesFormated += `<span class="MapResult-structureType">${structureType}</span>` 
  });

  if(structure.facebook !== '') {
    facebookProto = `
    <a href="${structure.facebook}" class="MapResult-link" tabindex="-1">
      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="50px" height="50px"><path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z"/></svg>
      <span class="sr-only">Facebook</span>
    </a>
    `
  }

  if(structure.web !== '') {
    webProto = `
      <a href="${structure.web}" class="MapResult-link" target="_blank" tabindex="-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58" xml:space="preserve"><path fill="currentColor" d="M50.688 48.222C55.232 43.101 58 36.369 58 29c0-7.667-2.996-14.643-7.872-19.834v-.001c-.004-.006-.01-.008-.013-.013C45.036 3.753 37.92.297 30.005.026l-.001-.001-.565-.015C29.293.005 29.147 0 29 0s-.293.005-.439.01l-.563.015-.001.001c-7.915.271-15.031 3.727-20.11 9.126-.004.005-.01.007-.013.013l-.001.002C2.996 14.357 0 21.333 0 29c0 7.369 2.768 14.101 7.312 19.222.006.009.006.019.013.028.018.025.044.037.063.06 5.106 5.708 12.432 9.385 20.608 9.665l.001.001.563.015c.147.004.293.009.44.009s.293-.005.439-.01l.563-.015.001-.001c8.185-.281 15.519-3.965 20.625-9.685.013-.017.034-.022.046-.04.008-.008.008-.018.014-.027zM2.025 30h12.003a36.956 36.956 0 0 0 2.415 12.217 36.873 36.873 0 0 0-8.111 4.131A26.875 26.875 0 0 1 2.025 30zm6.853-18.977a36.783 36.783 0 0 0 7.9 3.882A36.927 36.927 0 0 0 14.028 28H2.025a26.882 26.882 0 0 1 6.853-16.977zM55.975 28H43.972a36.927 36.927 0 0 0-2.75-13.095 36.783 36.783 0 0 0 7.9-3.882A26.882 26.882 0 0 1 55.975 28zM28 14.963a34.958 34.958 0 0 1-8.471-1.283A34.988 34.988 0 0 1 28 2.644v12.319zm0 2V28H16.028a34.926 34.926 0 0 1 2.666-12.475A36.948 36.948 0 0 0 28 16.963zm2 0c3.179-.085 6.3-.566 9.307-1.438A34.926 34.926 0 0 1 41.973 28H30V16.963zm0-2V2.644a34.988 34.988 0 0 1 8.471 11.036A34.958 34.958 0 0 1 30 14.963zm10.409-1.891a36.93 36.93 0 0 0-7.888-10.835 26.922 26.922 0 0 1 15.183 7.318 34.782 34.782 0 0 1-7.295 3.517zm-22.818 0a34.75 34.75 0 0 1-7.294-3.517A26.92 26.92 0 0 1 25.48 2.237a36.915 36.915 0 0 0-7.889 10.835zM16.028 30H28v10.038a36.883 36.883 0 0 0-9.661 1.541A34.924 34.924 0 0 1 16.028 30zM28 42.038v13.318a34.97 34.97 0 0 1-8.884-11.917A34.867 34.867 0 0 1 28 42.038zm2 13.318V42.038c3.039.085 6.017.556 8.884 1.4A34.964 34.964 0 0 1 30 55.356zm0-15.318V30h11.972a34.91 34.91 0 0 1-2.312 11.58A36.828 36.828 0 0 0 30 40.038zM43.972 30h12.003a26.87 26.87 0 0 1-6.307 16.348 36.873 36.873 0 0 0-8.111-4.131A36.93 36.93 0 0 0 43.972 30zM9.691 47.846a34.85 34.85 0 0 1 7.517-3.781 36.9 36.9 0 0 0 8.271 11.698c-6.151-.805-11.656-3.685-15.788-7.917zm22.83 7.917a36.878 36.878 0 0 0 8.271-11.698 34.874 34.874 0 0 1 7.517 3.781c-4.132 4.232-9.637 7.112-15.788 7.917z"/></svg>
        <span class="sr-only">Site internet</span>
      </a>
    `
  }

  const linksProto = `
    <div class="MapResult-links">
      ${facebookProto}
      ${webProto}
    </div>
  `

  if(structure.infos !== '') {
    const infosList = formatedInfos(structure.infos)
    infosProto = `
      <div class="MapResult-moreInfos">
        <button aria-controls="MapResult-moreInfosContainer" type="button" class="MapResult-moreInfosToggle" data-map-dropdown-button aria-expanded="false">
          <span>Plus d'informations</span>
          <svg width="18" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 1.931 16.069 0 9.095 6.974 2.132.01.201 1.941l8.883 8.883.022-.021.01.011L18 1.931Z" fill="currentColor"/></svg>
        </button>
        <div id="MapResult-moreInfosContainer" class="MapResult-moreInfosContainer" data-map-dropdown-infos tabindex="-1" aria-hidden="true">
          <div>${linksProto}</div>
          <div class="MapResult-moreInfosContent">${infosList}</div>
        </div>
      </div>
    `
  }

  if(structure.phone_number !== '') {
    phoneNumberProto = `
      <div class="MapResult-cta" data-tracking="button-phone"  data-map-result-button-container>
        <a aria-label="Appeler" class="Button Button--black Button--standaloneIcon" href="tel:${structure.phone_number.replaceAll('.', '')}" data-hover-opacity data-result-phone>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480.56 480.56">
            <path fill="currentColor" d="M365.354 317.9c-15.7-15.5-35.3-15.5-50.9 0-11.9 11.8-23.8 23.6-35.5 35.6-3.2 3.3-5.9 4-9.8 1.8-7.7-4.2-15.9-7.6-23.3-12.2-34.5-21.7-63.4-49.6-89-81-12.7-15.6-24-32.3-31.9-51.1-1.6-3.8-1.3-6.3 1.8-9.4 11.9-11.5 23.5-23.3 35.2-35.1 16.3-16.4 16.3-35.6-.1-52.1-9.3-9.4-18.6-18.6-27.9-28-9.6-9.6-19.1-19.3-28.8-28.8-15.7-15.3-35.3-15.3-50.9.1-12 11.8-23.5 23.9-35.7 35.5-11.3 10.7-17 23.8-18.2 39.1-1.9 24.9 4.2 48.4 12.8 71.3 17.6 47.4 44.4 89.5 76.9 128.1 43.9 52.2 96.3 93.5 157.6 123.3 27.6 13.4 56.2 23.7 87.3 25.4 21.4 1.2 40-4.2 54.9-20.9 10.2-11.4 21.7-21.8 32.5-32.7 16-16.2 16.1-35.8.2-51.8-19-19.1-38.1-38.1-57.2-57.1zM346.254 238.2l36.9-6.3c-5.8-33.9-21.8-64.6-46.1-89-25.7-25.7-58.2-41.9-94-46.9l-5.2 37.1c27.7 3.9 52.9 16.4 72.8 36.3 18.8 18.8 31.1 42.6 35.6 68.8zM403.954 77.8c-42.6-42.6-96.5-69.5-156-77.8l-5.2 37.1c51.4 7.2 98 30.5 134.8 67.2 34.9 34.9 57.8 79 66.1 127.5l36.9-6.3c-9.7-56.2-36.2-107.2-76.6-147.7z"/>
          </svg>
        </a>
        <span class="MapResult-ctaLegend">Appeler</span>
      </div>
    `
  }

  return `
    <div class="MapResult" data-tracking="itinerary-click" data-result-index="${index + 1}">
      <div class="MapResult-container">
        <div class="MapResult-content">
          <div class="MapResult-infos">
            <span class="MapResult-name" tabindex="0">${structure.name}</span>
            <address class="MapResult-address">
              <div class="MapResult-structureTypes">${structureTypesFormated}</div>
              <span class="MapResult-address" data-map-result-adress="${structure.address1}">${structure.address1}</span>
              <span class="MapResult-city">${postcode} ${structure.city}</span>
            </address>
            <span class="MapResult-phone">Tel: ${structure.phone_number}</span>
            ${infosProto}
          </div>
          <div class="MapResult-ctaContainer" data-map-result-container>
            ${phoneNumberProto}
            <div class="MapResult-cta" data-map-result-button-container>
              <button aria-label="Se rendre à la destination" class="Button Button--black Button--standaloneIcon"  data-hover-opacity data-google-map-button data-lat="${mapParams.mapCenter.lat}" data-lng="${mapParams.mapCenter.lng}">
                <svg width="17" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 4.866a1 1 0 0 0 0-1.732L12 .536a1 1 0 0 0-1.5.866v1.757C5.045 4.036.77 8.443.094 13.963c-.07.563.392 1.037.96 1.037.534 0 .972-.421 1.045-.95A10.509 10.509 0 0 1 10.5 5.19v1.408a1 1 0 0 0 1.5.866l4.5-2.598Z" fill="currentColor"/></svg>
                <span class="sr-only">Accéder au plan Google Maps</span>
              </button>
              <span class="MapResult-ctaLegend">S'y&nbsp;rendre</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}

function formatedInfos(string) {

  const infosArray = string.split('&#149;')
  const filteredInfosArray = infosArray.filter(Boolean); // remove empty string
  
  let infosList = '<ul>'
  
  filteredInfosArray.forEach(elem => {
    let isLongWord = elem.indexOf('@') > 0 || elem.indexOf('http') >= 0 
    
    if(isLongWord) {
      const elemArray = elem.split(' ')
      
      elemArray.forEach((el, index) => {    
        const ismail = el.indexOf('@') > 0
        const isLink = el.indexOf('http') >= 0     
        
        if(ismail) {
          elemArray[index] = `<a tabindex="-1" href="mailto:${el}">${el}</a>` 
        }
        if(isLink) {
          elemArray[index] = `<a tabindex="-1" href="${el}">${el}</a>` 
        }


      });

      elem = elemArray.join(' ')
    }

    const item = `<li>${elem}</li>`
    infosList += item
  });
  
  infosList += '</ul>'

  return infosList
}

export function initDropdown () {
  const dropdownButtons = document.querySelectorAll('[data-map-dropdown-button]')

  dropdownButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopImmediatePropagation()
      const element = e.target
      const infos = element.nextElementSibling

      toggleInfos(element, infos)
    })
  });
}

function toggleInfos(button, container) {
  const isOpen = button.getAttribute('aria-expanded') === 'true'
  const infoLinks = container.querySelectorAll('a, button')

  if(isOpen) {
    button.setAttribute('aria-expanded', 'false')
    container.setAttribute('aria-hidden', 'true')
    infoLinks.forEach(link => {
      link.setAttribute('tabindex', '-1')
    });
  }else {
    button.setAttribute('aria-expanded', 'true')
    container.setAttribute('aria-hidden', 'false')
    infoLinks.forEach(link => {
      link.setAttribute('tabindex', '0')
    });
  }
}

export function openMap(){
  
  const googleMapButtons = document.querySelectorAll('[data-google-map-button]')
  let platform = getPlatform()
  
  googleMapButtons.forEach(button => {

    button.addEventListener('click', (e) => {
      
      const address = button.closest('[data-map-result]').querySelector('[data-map-result-adress]').getAttribute('data-map-result-adress')
      trackingAddress()

      if (!window.matchMedia("(min-width: 1100px)").matches) e.preventDefault()
      // window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${elementLat},${elementLng}`);
      window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${encodeURIComponent(address)}`, '_blank');
    })
  });
}

function getPlatform() {
  let platform

  if(navigator) {
    if(navigator.userAgentData) {
      platform = navigator.userAgentData.platform
    }
    platform = navigator.platform || 'unknown'
  }else{
    platform = 'unknown'
  }

  return platform
}

// Click on list's structure to zoom on the map
function onStructureClick() {
  const structures = document.querySelectorAll('[data-map-result]')

  structures.forEach(structure => {
    structure.addEventListener('click', (e) => {

      if (e.target.classList.contains('Button')) return

      const indexElement = structure.querySelector('[data-result-index]')
      const index = parseInt(indexElement.getAttribute('data-result-index')) - 1
      
      const coordinates = {
        lat: store.structures[index].latitude,
        lng: store.structures[index].longitude
      }

      structures.forEach(structure => {
        structure.classList.remove('MapResults-result--is-selected')
      })

      if (!e.currentTarget.classList.contains('MapResults-result--is-selected')) {
        e.currentTarget.classList.add('MapResults-result--is-selected')

        map.setCenter(coordinates)
        map.setZoom(mapParams.zoom.max)

        store.infoWindows.forEach(infoWindow => infoWindow.close())
        store.infoWindows[index].open(map, store.markers[index])
        setTimeout(() => {
          structure.querySelector('.MapResult-name').focus()
        }, 100);

        console.log(structure.querySelector('.MapResult-name'))
      }
    })
  })
}

export function updateStructureList() {
  
  resultsList.innerHTML = '' // reset result list

  listParams.pageNb = Math.ceil(store.structures.length / listParams.limitPerPage)
  const offset = listParams.currentPage * 10

  const structuresList = store.structures.slice(offset, offset + listParams.limitPerPage)
  
  structuresList.forEach((structure, index) => {
    const newStructure = document.createElement('div')
    const newStructureContent = getPrototype(offset + index, structure)

    newStructure.classList.add('MapResults-result')
    newStructure.setAttribute('data-map-result', '')
    newStructure.innerHTML = newStructureContent

    
    resultsList.appendChild(newStructure)

    const resultList = resultsList.querySelectorAll('[data-map-result]')
    resultList.forEach(result => {
      const structureName = result.querySelector('.MapResult-name').innerText
      result.setAttribute('tabindex', '0')
    })

    store.farthestStructure = structure // Last structure of the list
    store.listedStructureCount = offset + index + 1
  })

  if(!structuresList.length) { showEmptyResults(resultsList) }
  if(structuresList.length) { showNumberOnClick()}

  updateMapCenter()
  updateMapZoom()
  updateMapMarkers(offset)
  updateMapInfoWindows(offset)
  onMarkerClick()
  onStructureClick()
  updatePagination()
}

function showEmptyResults(parentElement) {
  parentElement.innerHTML = '<p class="MapResults-empty">Aucun résultat. Aucun centre n\'est présent dans un rayon de 5km autour de l\'adresse renseignée</p>'
}

function showNumberOnClick() {
  const phoneNumerButtons = document.querySelectorAll('[data-result-phone]')
  
  phoneNumerButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      trackingPhone()
    })
    const number = button.href.split(':').pop()
    const tooltip = createTooltip(number)
    button.append(tooltip)
    
    if (window.matchMedia("(min-width: 1100px)").matches) {
      button.addEventListener('click', showTooltip)
    }else {
      button.removeEventListener('click', showTooltip)
    }
  });
}

function trackingAddress(){
  return tC.event.itineraryClick(this, {'pageType':'annuaire'});
}

function trackingPhone(){
  return tC.event.phoneNumberClick(this, {'pageType': 'annuaire'})
}

function createTooltip(content) {
  const tooltip = document.createElement('div')
  tooltip.setAttribute('data-map-result-tooltip', '')
  tooltip.setAttribute('aria-hidden', 'true')
  tooltip.setAttribute('data-tracking', 'button-phone')
  tooltip.classList.add('MapResult-tooltip')
  tooltip.innerHTML = content
  return tooltip
}

let isVisible = false
const showTooltip = (e) => {
  e.preventDefault()
  const button = e.target
  const tooltip = button.querySelector('[data-map-result-tooltip]')
  
  if(isVisible){
    tooltip.setAttribute('aria-hidden', 'true')
    isVisible = false
  }else {
    tooltip.setAttribute('aria-hidden', 'false')
    isVisible = true
  }
}
